import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { Select, MenuItem, InputLabel } from '@material-ui/core';

import "moment/locale/pt-br"
import styles from './styles.module.scss'
import { getParceiros, getRegional, getFilial, getListaParceirosAcao, perfis, saveAdmin, alterAdmin, getAdmin, aproveAdmin } from '../../services/api-auto';
import services from '../../services';


import { useDispatch } from "react-redux"
import {
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';
import { useDebounce } from '../../hooks/debounceHook'
import ModalLoading from '../../components/ModalLoading'
import service from '../../services'
import PasswordStrength from '../../components/PasswordStrength'

import LojasAdicionadas from './components/LojasAdicionadas';
import FiliaisAdicionadas from './components/FiliaisAdicionadas';
import RegionaisAdicionadas from './components/RegionaisAdicionadas';
import ParceiroCard from '../../components/ParceiroCard';
import VoltarHome from '../../components/VoltarHomeBtn/voltarHome';
import Paginacao from '../../components/Paginacao'
import AcoesUser from '../../components/ButtonsAcoes';



const dataInit = {
    userId: "",
    nomeCompleto: "",
    cpf: "",
    email: "",
    phoneNumber: "",
    cargo: "",
    perfilAcesso: "",
    perfilAcessoAtual: "",
    senha: "",
    confirmarSenha: "",
    status: "",
    usuarioAprovador: "",

    listaAddPdvGenFilial: [],
    listaAddPdvGenRelacio: [],
    listaAddPdvSuperInt: [],
    listaRemovePdvGenFilial: [],
    listaRemovePdvGenRelacio: [],
    listaRemovePdvSuperInt: [],
}

const cargoInit = {
    roleId: '',
    displayName: ''
}


const Detalhes = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const [data, setData] = useState(dataInit);
    const [regional, setRegional] = useState([]);

    const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
    const [filial, setFilial] = useState([]);
    const [filialSelecionado, setFilialSelecionado] = useState('todos');
    const [parceiros, setParceiros] = useState([]);
    const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
    const [perfisList, setPerfisList] = useState([]);

    const history = useHistory()


    const [nomeParceiroSelecionado, setNomeParceiroSelecionado] = useState('todos');
    const [parceiroAcaoPresentes, setParceiroAcaoPresentes] = useState([])
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [permiteAlterar, setPermiteAlterar] = useState(services.storage.getClaimValues("MeusDados", "Alterar"));

    const validarForm = () => {
        let valid = true
        let msg = ""

        if (!data.nomeCompleto) {
            let msg = `Campo nome obrigatório`;
            valid = false;
            showMsgW(msg)
        }
        if (!data.cpf) {
            msg = "Campo CPF é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.email) {
            msg = "Campo E-mail é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.phoneNumber) {
            msg = "Campo Celular é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.cargo) {
            msg = "Campo cargo é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (data.perfilAcesso == null) {
            msg = "Campo perfil é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.userId && !data.senha) {
            msg = "Campo Confirmar Senha é obrigatórios\n";
            valid = false;
            showMsgW(msg)
        }
        if (data.senha && !data.confirmarSenha) {
            msg = "Campo Confirmar Senha é obrigatórios\n";
            valid = false;
            showMsgW(msg)
        }

        return valid
    }

    const encerrar = async () => {
        setModalLoading(true)
        try {
            await aproveAdmin(data.userId);
            localStorage.removeItem("adminPendente")
            showMsgS((data.status === "Aprovado") ? "Usuário Bloqueado com sucesso" : "Usuário ativado com sucesso")
            setTimeout(
                () => { history.push('/administradores') },
                2000
            )
        } catch (e) {
            showMsgW((data.status === "Aprovado") ? "Erro ao Bloquear usuário" : "Erro ao ativar usuário")
        } finally {
            setModalLoading(false)
        }
    }

    const getCampanhaIfEdit = async (id) => {
        if (id) {
            setModalLoading(true)
            try {
                const info = await getAdmin(id);

                setData({
                    ...data,
                    userId: info.data.userId,
                    nomeCompleto: info.data.nomeCompleto,
                    cpf: info.data.cpf,
                    email: info.data.email,
                    phoneNumber: info.data.phoneNumber,
                    cargo: info.data.cargo,
                    perfilAcesso: info.data.perfilAcesso,
                    perfilAcessoAtual: info.data.perfilAcesso,
                    status: info.data.status,

                    usuarioAprovador: info.data.usuarioAprovador,

                    listaAddPdvGenFilial: info.data.listaAddPdvGenFilial || [],
                    listaAddPdvGenRelacio: info.data.listaAddPdvGenRelacio || [],
                    listaAddPdvSuperInt: info.data.listaAddPdvSuperInt || [],
                    listaRemovePdvGenFilial: info.data.listaRemovePdvGenFilial || [],
                    listaRemovePdvGenRelacio: info.data.listaRemovePdvGenRelacio || [],
                    listaRemovePdvSuperInt: info.data.listaRemovePdvSuperInt || [],

                })

            } catch (e) {
                showMsgW('Não foi possível carregar os dados')
            } finally {
                setModalLoading(false)
            }
        }
    }

    const adicionarParceiro = () => {

        if (regionalSelecionado === "todos") {
            showMsgW('Selecione uma regional')
            return 0
        }

        switch (data.perfilAcesso) {
            case 4:
                const obj1 = {
                    "regional": regionalSelecionado,
                    "filial": filialSelecionado,
                    "nomeParceiro": nomeParceiroSelecionado,
                    "idParceiro": parceiroSelecionado,
                }
                setData({ ...data, listaAddPdvGenRelacio: [...data.listaAddPdvGenRelacio, obj1] });
                break;
            case 3:
                const obj2 = {
                    "regional": regionalSelecionado,
                    "filial": filialSelecionado,
                }
                setData({ ...data, listaAddPdvGenFilial: [...data.listaAddPdvGenFilial, obj2] });
                break;
            case 2:
                const obj3 = {
                    "regional": regionalSelecionado,
                }
                setData({ ...data, listaAddPdvSuperInt: [...data.listaAddPdvSuperInt, obj3] });
                break;

            default:
                break;
        }
    }

    const removerParceiro = (parceiro) => {
        let adicionados
        let index
        switch (data.perfilAcesso) {
            case 4:
                adicionados = [...data.listaAddPdvGenRelacio];
                index = adicionados.findIndex(item => item.nomeParceiro === parceiro)
                adicionados.splice(index, 1)
                setData({ ...data, listaAddPdvGenRelacio: adicionados })
                break;
            case 3:
                adicionados = [...data.listaAddPdvGenFilial];
                index = adicionados.findIndex(item => item.filial === parceiro)
                adicionados.splice(index, 1)
                setData({ ...data, listaAddPdvGenFilial: adicionados })
                break;
            case 2:
                adicionados = [...data.listaAddPdvSuperInt];
                adicionados = adicionados.filter((item) => { return item.regional !== parceiro })
                //adicionados.splice(index,1)
                setData({ ...data, listaAddPdvSuperInt: adicionados })
                break;
            default:
                break;
        }
    }

    const deletarParceiro = (parceiro) => {
        let presentes = [...parceiroAcaoPresentes];
        let index = presentes.findIndex(item => item === parceiro)
        presentes.splice(index, 1)

        setData({ ...data, parceiroAcaoExcluidos: [...data.parceiroAcaoExcluidos, parceiro] })
        setParceiroAcaoPresentes(presentes)
    }

    const carregarRegional = async () =>{
        const info = await getRegional()
        setRegional(info);
    }

    const carregarFilial = async () => {
        setModalLoading(true)
        try {
            const info = await getFilial(regionalSelecionado)
            setFilial(info);
        } catch (e) {
            showMsgE("Ocorreu um erro ao carregar os Filiais")
        } finally {
            setModalLoading(false)
        }
    }

    const carregarParceiro = async () => {
        setModalLoading(true)
        try {
            const info = await getParceiros(regionalSelecionado, filialSelecionado)
            setParceiros(info);
        } catch (e) {
            showMsgE("Ocorreu um erro ao carregar os Parceiros")
        } finally {
            setModalLoading(false)
        }
    }

    const createSenderForm = () => {
        let formdata = {};

        if (data.userId !== '') { formdata.userId = data.userId; }

        formdata.nomeCompleto = data.nomeCompleto
        formdata.email = data.email
        formdata.phoneNumber = service.mask.unMask(data.phoneNumber)
        formdata.cargo = data.cargo
        formdata.usuarioAprovador = data.usuarioAprovador
        formdata.perfilAcesso = data.perfilAcesso
        formdata.cpf = service.mask.unMask(data.cpf)
        formdata.senha = data.senha
        formdata.confirmaSenha = data.confirmarSenha
        formdata.listaAddPdvGenFilial = data.listaAddPdvGenFilial
        formdata.listaAddPdvGenRelacio = data.listaAddPdvGenRelacio
        formdata.listaAddPdvSuperInt = data.listaAddPdvSuperInt
        formdata.listaRemovePdvGenFilial = data.listaRemovePdvGenFilial
        formdata.listaRemovePdvGenRelacio = data.listaRemovePdvGenRelacio
        formdata.listaRemovePdvSuperInt = data.listaRemovePdvSuperInt

        return formdata;
    }

    const enviar = async () => {
        setIndicarErros(false)
        if (validarForm()) {
            let formdata = createSenderForm()
            setModalLoading(true)
            try {
                let info = await alterAdmin(formdata);
                showMsgS("Dados salvos com sucesso!")
                setTimeout(() => {
                    history.push('/administradores')
                }, 2000)
            } catch (e) {
                showMsgE("Ocorreu um erro ao salvar os dados")
            }
            setModalLoading(false)
        }
    }

    const pesquisar = async (id) => {
        const info = await getListaParceirosAcao(id, search, page)
        setParceiroAcaoPresentes(info.data)
        setMaxPage(info.maxPage)
    }

    useDebounce(search, 750, () => { pesquisar(data.id) });

    const loadPerfil = async () => {
        const info = await perfis()
        setPerfisList(info.data)
    }

    const handlerPerfil = (e) => {
        const newData = { ...data, perfilAcesso: e.target.value }

        if (e.target.value !== 0) {
            newData.usuarioAprovador = false
        }

        setData(newData)
    }

    useEffect(() => {
        carregarRegional();
        const adm = services.storage.getUser()
        getCampanhaIfEdit(adm.userId)
        loadPerfil()
    }, [])

    useEffect(() => {
        if (regionalSelecionado) {
            carregarFilial();
        }
    }, [regionalSelecionado])

    useEffect(() => {
        if (filialSelecionado) {
            carregarParceiro();
        }
    }, [filialSelecionado])

    useEffect(() => {
        if (data.id) {
            pesquisar(data.id)
        }
    }, [page])

    const handlerAprovador = (event) => {
        if (data.perfilAcesso === 0) {
            setData({ ...data, usuarioAprovador: event.target.checked })
        } else {
            setData({ ...data, usuarioAprovador: false })
        }
    }

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    Meus Dados
                    <VoltarHome />
                </div>
                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card}>
                            <div className={styles.subtitle}>
                                Dados pessoais
                            </div>
                            <FormControl className={styles.half}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, nomeCompleto: e.target.value }) }}
                                    label="Nome completo"
                                    inputvariant="outlined"
                                    value={data.nomeCompleto}
                                    variant="filled"
                                    error={indicarErros && !data.nome ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>

                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, cpf: e.target.value }) }}
                                    label="CPF"
                                    value={service.mask.cpf(data.cpf)}
                                    variant="filled"
                                    error={indicarErros && !data.cpf ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, email: e.target.value }) }}
                                    label="E-mail"
                                    value={data.email}
                                    variant="filled"
                                    error={indicarErros && !data.email ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text"
                                    onChange={(e) => { setData({ ...data, phoneNumber: service.mask.celphone(e.target.value) }) }}
                                    label="Celular"
                                    value={service.mask.celphone(data.phoneNumber)}
                                    variant="filled"
                                    error={indicarErros && !data.phoneNumber ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAlterar}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Cargo
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Cargo"
                                    onChange={(e) => { setData({ ...data, cargo: e.target.value }) }}
                                    value={data.cargo}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={data.perfilAcessoAtual !== 1}
                                >
                                    {
                                        perfisList.map((item) => {
                                            return (
                                                <MenuItem value={item.displayName} key={item.roleId}>
                                                    {item.displayName}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <div className={styles.subtitle}>
                                Configurações de acesso
                            </div>
                            <FormControl className={styles.half}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Perfil de acesso
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="perfil"
                                    onChange={(e) => { handlerPerfil(e) }}
                                    value={data.perfilAcesso}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={data.perfilAcessoAtual !== 1}

                                >
                                    <MenuItem value={1}>Master</MenuItem>
                                    <MenuItem value={2}>Superintendente</MenuItem>
                                    <MenuItem value={3}>Gerente Filial</MenuItem>
                                    <MenuItem value={4}>Gerente Relacionamento</MenuItem>
                                    <MenuItem value={7}>Call Center</MenuItem>
                                </Select>
                            </FormControl>
                            {
                                (data.perfilAcessoAtual === 1) && (
                                    <div className={`${styles.half} ${styles.centerCheckbox}`}>
                                        <input
                                            className={styles.check}
                                            type='checkbox'
                                            checked={data.usuarioAprovador}
                                            onChange={(event) => { handlerAprovador(event) }}
                                            labelId='aprovador-label'
                                            disabled={!permiteAlterar}
                                        />

                                        Aprovador
                                    </div>
                                )
                            }

                            <div className='col-sm-12'>
                                <FormControl  >
                                    <TextField label="Senha" type="password" size="small"
                                        onChange={event => { setData({ ...data, senha: event.target.value }) }}
                                        value={data.senha}
                                        variant="filled"
                                        className="customFilledInput"
                                        disabled={!permiteAlterar}
                                    />
                                </FormControl>
                            </div>

                            <PasswordStrength password={data.senha} />

                            <div className='col-sm-12'>
                                <FormControl>
                                    <TextField label="Confirme sua senha" type="password" size="small"
                                        onChange={event => { setData({ ...data, confirmarSenha: event.target.value }) }}
                                        value={data.confirmarSenha}
                                        variant="filled"
                                        className="customFilledInput"
                                        disabled={!permiteAlterar}
                                    />
                                </FormControl>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    data.perfilAcessoAtual !== 1 && (
                        <div className={` ${styles.content}`}>
                            <div className={`${styles.card} ${styles.white}`}>
                                <div className={styles.subtitle}>
                                    {(data.perfilAcessoAtual === 4) && 'Lojas'}
                                    {(data.perfilAcessoAtual === 3) && 'Filiais'}
                                    {(data.perfilAcessoAtual === 2) && 'Superintendência'}
                                </div>
                                <div>
                                    <div className={styles.addLojasWrapper}>
                                        {
                                            data.perfilAcessoAtual === 4 &&
                                            Boolean(data.listaAddPdvGenRelacio.length) &&
                                            data.listaAddPdvGenRelacio.map((loja) => {
                                                return (
                                                    <ParceiroCard
                                                        parceiro={loja}
                                                        key={loja.idLoja}
                                                        idPerfilAcesso={data.perfilAcessoAtual} />
                                                )
                                            })
                                        }
                                        {
                                            data.perfilAcessoAtual === 2 &&
                                            Boolean(data.listaAddPdvSuperInt.length) &&
                                            data.listaAddPdvSuperInt.map((regional) => {
                                                return (
                                                    <ParceiroCard
                                                        parceiro={regional}
                                                        key={regional.idRegional}
                                                        idPerfilAcesso={data.perfilAcessoAtual} />
                                                )
                                            })
                                        }
                                        {
                                            data.perfilAcessoAtual === 3 &&
                                            Boolean(data.listaAddPdvGenFilial.length) &&
                                            data.listaAddPdvGenFilial.map((filial) => {
                                                return (
                                                    <ParceiroCard
                                                        parceiro={filial}
                                                        key={filial.idFilial}
                                                        idPerfilAcesso={data.perfilAcessoAtual} />
                                                )
                                            })
                                        }
                                    </div>
                                    {maxPage > 1 && (
                                        <Paginacao maxPage={maxPage} page={page} setPage={setPage} />
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                }

                {permiteAlterar && (
                    <div className={styles.blueBackground}>
                        <div className={styles.content}>
                            <div className={styles.card}>
                                <AcoesUser status={data.status === "Aprovado" ? "Ativo" : "Inativo"}
                                    key={data.userId}
                                    encerrar={encerrar}
                                    enviar={enviar}
                                    disabled={false}
                                    msgDialog={'Deseja cancelar esta ação? Todos os dados não salvos serão perdidos.'}
                                    redirect={'/Home'}
                                    claimName={'MeusDados'}
                                />
                            </div>
                        </div>
                    </div>
                )}


            </div>
            <ModalLoading
                open={modalLoading}
                size="lg"
            />

        </>
    );
}

export default Detalhes;